import { Injectable, } from '@angular/core';
import { NotificationRef, NotificationService } from '@progress/kendo-angular-notification';
import { CustomNotificationComponent } from '../components/custom-notification/custom-notification.component';
@Injectable({
  providedIn: 'root',
})
export class CommonService {

  // Notification Start
  prevNotificationMessage: string = '';
  prevNotificationType: string = '';
  prevNotification: NotificationRef | null = null;
  prevNotificationCanCloseByNavigation: boolean = false;
  // Notification End
  constructor( 
    private notificationService: NotificationService,

  ) { }
 
  getFileType(type: string) {
    switch (type) {
      case 'txt':
        return "text/plain";
      case 'pdf':
        return "application/pdf";
      case 'jpg':
        return "image/jpeg";
      case 'jpeg':
        return "image/jpeg";
      case 'json':
        return "application/json";
      case 'png':
        return "image/png";
      case 'xls':
        return "application/vnd.ms-excel";
      case 'xlsx':
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case 'xml':
        return "application/xml";
      case 'doc':
        return "application/msword";
      case 'docx':
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case 'csv':
        return "text/csv";
      default:
        return "";
    }
  }

  showNotificationMessage(messageText: string,
    messageType: 'none' | 'success' | 'warning' | 'error' | 'info',
    position: 'left' | 'center' | 'right' = 'center', _duration?: number, canCloseByNav: boolean = true,
    height: number = 40, width: number = 400) {

    //if same error 
    if (messageText) {
      if (this.prevNotification != null) {
        this.prevNotification.hide();
      }

      let notification = this.notificationService.show({
        content: CustomNotificationComponent,
        // content: messageText,
        cssClass: 'mt-20 notification-msg-status',
        animation: { type: 'slide', duration: _duration ? _duration : 200 },
        position: { horizontal: position, vertical: 'top' },
        type: { style: messageType, icon: true },
        closable: true,
        height: height,
        width: width,
      });

      if (notification.content) {
        notification.content.instance.content = messageText;
      }

      if (messageType != "error" && messageType != "warning")
        this.notfificationHide(notification);

      this.prevNotificationMessage = messageText;
      this.prevNotificationType = messageType;
      this.prevNotification = notification;
      this.prevNotificationCanCloseByNavigation = canCloseByNav;
    }
  }

  private notfificationHide(notification: any, timeOut: number = 10000) {
    setTimeout(() => {
      notification.hide();
    }, timeOut);
  }
}
